/**
 * @file payOrderStatus.js
 * @description 微信订单支付成功 / 关闭判断
 * @module shared/utils/payOrderStatus
 */

/**
 * @param {{ orderStatus?: string, paymentStatus?: string }|null|undefined} vo
 * @returns {boolean}
 */
export function isWechatOrderPaid(vo) {
  if (!vo) return false
  if (vo.orderStatus !== 'PAID') return false
  // 有 paymentStatus 时须为 SUCCESS（橘子币充值文档约定）；打赏等旧单可能只给 PAID
  if (vo.paymentStatus && vo.paymentStatus !== 'SUCCESS') return false
  return true
}

/**
 * @param {{ orderStatus?: string, paymentStatus?: string }|null|undefined} vo
 * @returns {boolean}
 */
export function isWechatOrderClosed(vo) {
  if (!vo) return false
  if (vo.orderStatus === 'CLOSED' || vo.orderStatus === 'CANCELLED') return true
  return vo.paymentStatus === 'CLOSED' || vo.paymentStatus === 'PAYERROR'
}
